import { Select, SelectProps } from 'antd';
import { FC, memo } from 'react';

import { FormSelectNotFoundContent } from '@/common/components';
import { useGetPagesCriticalCssStyleFilesQuery } from '@/modules/Pages/queries/pages-critical-css.queries';

interface Props extends Omit<SelectProps, 'options' | 'placeholder'> {
  siteId: string;
}

export const PagesCriticalCssStyleFilesSelect: FC<Props> = memo(
  ({ siteId, value, onChange, disabled, ...props }) => {
    const { data, isLoading, isError, error } = useGetPagesCriticalCssStyleFilesQuery(siteId)();

    const optionsData =
      data?.map((file) => ({
        value: file.id,
        label: `${file.name}.css`,
      })) ?? [];

    return (
      <Select
        {...props}
        mode="tags"
        allowClear
        showSearch
        optionFilterProp="label"
        placeholder="Оберіть файли стилів"
        loading={isLoading}
        disabled={disabled || isLoading}
        value={value}
        onChange={onChange}
        notFoundContent={
          <FormSelectNotFoundContent description="Немає доступних файлів стилів" isError={isError} error={error} />
        }
        options={optionsData}
      />
    );
  },
);
